import { Component} from 'react';
import history from '../history';
import Cookies from 'universal-cookie';

class StartTest extends Component {
	state = {};

	constructor(props) {
		super(props);
		const cookies = new Cookies();

		cookies.set('key', '3fcfa1d9178290b9fc5404c6603b96ab', { path: '/' });

		history.push(`/introduction`);
	}

	render() {
		return(
		    ""
		);
	}
}

export default StartTest;



// WEBPACK FOOTER //
// ./src/views/StartTestView.jsx